<div>
    <h4>New user?</h4>
    <div>
        <a [routerLink]="['/create-account']">Sign up for a {{brandName}} Account now!</a>
    </div>
    <br />
    <div>
        <h5>Sign up to:</h5>
        <ul>
            <li *ngIf="brandId === BrandEnum.CELPIP">Access 2 FREE practice tests</li>
            <li *ngIf="brandId === BrandEnum.CAEL">Access a FREE practice test</li>
            <li *ngIf="brandId === BrandEnum.CELPIP">Receive a FREE CELPIP Accelerate – Starter course</li>
            <li>Register for a test</li>
            <li>View information about upcoming tests</li>
            <li>Purchase study materials</li>
            <li>Transfer or cancel a test registration</li>
            <li>Request a re-evaluation of your test</li>
            <li>View test scores</li>
            <li *ngIf="!launchSRDownload || brandId === BrandEnum.CAEL">Order score reports</li>
            <li *ngIf="launchSRDownload && brandId === BrandEnum.CELPIP">Download CELPIP Official Score Report</li>
            <li>Update your account information</li>
        </ul>
    </div>
</div>
